((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Accounts.All",
            {
                url: "/All",
                component: "allAccounts",
                data: {
                    pageTitle: "Accounts"
                }
            });
    });

    app.component("allAccounts",
        {
            templateUrl: "/App/Accounts/AllAccounts/all-accounts.html",
            controller: allAccountsController,
            bindings: {
                currentUser: "<"
            }
        });

    function allAccountsController($state, allAccountsDataTable, userApi, $mdDialog) {
        const $ctrl = this;

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error retrieving accounts occured.",
            textContent: "Please refresh the page and try again.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        const getCurrentUserAccounts = (nextPageToken) => {
            return userApi.getUserAccounts($ctrl.currentUser.Id, nextPageToken).then(accounts => {
                if (!accounts.NextPage) return accounts;

                return getCurrentUserAccounts(accounts.NextPage).then(response => {
                    return accounts.concat(response);
                });
            });
        };

        this.$onInit = () => {
            $ctrl.accounts = [];

            $ctrl.ui = {
                loading: true
            };

            getCurrentUserAccounts().then(response => {
                $ctrl.accounts = response;                
                $ctrl.dataTableOptions = allAccountsDataTable.buildDataTableOptions($ctrl.accounts);

                $ctrl.ui.loading = false;
            }).catch(error => {
                $ctrl.ui.loading = false;
                $mdDialog.show(errorAlert);
            })
        };

        ng.extend($ctrl,
            {
            });
    }

})(window.app, window.angular);